// extracted by mini-css-extract-plugin
export default {"footer":"Contact_footer__2dhjZ","container":"Contact_container__J1LZ1","section":"Contact_section__9Wxix","map":"Contact_map__K11U2","footerBottom":"Contact_footerBottom__BxFrH"};